import { Download, X } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";

const ImagePopup = ({ imageUrl, onClose }) => {
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const dragStart = useRef({ x: 0, y: 0 });

  const handleClose = useCallback(() => {
    setZoom(1);
    setPosition({ x: 0, y: 0 });
    onClose();
  }, [onClose]);

  // Fechar com ESC
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleClose]);

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = -e.deltaY * 0.001;
    setZoom((prev) => Math.min(Math.max(prev + delta, 1), 4));
  };

  const handleMouseDown = (e) => {
    if (zoom > 1) {
      setIsDragging(true);
      dragStart.current = {
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      };
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - dragStart.current.x,
        y: e.clientY - dragStart.current.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  if (!imageUrl) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
      onClick={handleClose}
      onWheel={handleWheel}
    >
      <div
        className="relative overflow-hidden"
        onClick={(e) => e.stopPropagation()}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        <div className="absolute right-4 top-4 z-50 flex gap-2">
          <a
            href={imageUrl}
            download
            onClick={(e) => e.stopPropagation()}
            className="rounded-full bg-white/80 p-2 text-black shadow hover:bg-white"
            title="Baixar imagem"
          >
            <Download />
          </a>

          <button
            onClick={handleClose}
            className="rounded-full bg-white/80 p-2 text-black shadow hover:bg-white"
          >
            <X />
          </button>
        </div>

        <img
          src={imageUrl}
          alt="Imagem ampliada"
          draggable={false}
          onMouseDown={handleMouseDown}
          className="cursor-grab select-none transition-transform duration-100"
          style={{
            transform: `scale(${zoom}) translate(${position.x / zoom}px, ${
              position.y / zoom
            }px)`,
            maxHeight: "90vh",
            maxWidth: "90vw",
          }}
        />
      </div>
    </div>
  );
};

export default ImagePopup;
